import React from 'react';

import CompanyLogoWrap from 'sections/ScreverOcxProgram/components/CompanyLogoWrap';
import Socials from './Socials';

import { footer, inner, companies } from './styles.module.scss';

const Footer = () => {
  return (
    <footer className={footer}>
      <div className="scr-wrap">
        <div className={inner}>
          <div className={companies}>
            <CompanyLogoWrap />
          </div>

          <Socials />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
